<div class="cart-container">
  <div class="cart__header">
    <div class="cart__header--product-title">
      {{ "modeso_cart_cart-product-list_table-col-product-title" | injectedText | async }}</div>
    <div class="cart__header--amount">
      {{ "modeso_cart_cart-product-list_table-col-amount-title" | injectedText | async }}</div>
    <div class="cart__header--price">{{ "modeso_cart_cart-product-list_table-col-price-title" | injectedText | async }}
    </div>
  </div>
  <div *ngFor="let product of products" class="cart">
    <div class="cart__body">
      <div class="cart__body--image">
        <img src={{product.image}} alt="{{product.title}}">
      </div>
      <div class="cart__body--product-title" id="productTitle">{{product.title}}</div>
      <div class="cart__body--description">
        <p class="cart__body--description">{{ "modeso_product_cart_description" | injectedText | async }}: CHF {{product.price | number : '1.2'}}</p>
      </div>
      <div *ngIf="ChangeProductAmountFaild && product.productId === productId && product.price === currentProductPrice" class="cart-limit-exceeded-error">
        {{ "modeso_cart_add-to-cart_total_exceeded_error" | injectedText | async }}
      </div>
      <modeso-counter class="cart__body--amount" 
      [amount]="product.amount" 
      [counterError]="(ChangeProductAmountFaild && product.productId === productId) ? true : false"
      (changeAmountEvent)="onChangeAmount($event, product)"></modeso-counter>
      <div class="cart__body--remove-products" >
        <a (click)="deleteFromCart(product)">{{ "modeso_cart_cart-product-list_remove-button-caption" | injectedText | async }}</a>
      </div>
      <div class="cart__body--price"> CHF
        {{ (product.isPackagingSelected ? (product.amount * ( product.price + product.packagePrice )) :  ( product.amount * product.price )) | number : '1.2' }}
      </div>
    </div>
  </div>
</div>
